import styled from 'styled-components';

const HoverText = styled.span`
    color: #000;
    :hover {
        color: #1f496d;
        cursor: pointer;
    }`

export default HoverText;